import styled from 'styled-components'

export const HeaderContainer = styled.div`
  position: relative;
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 2px 0px 2px 16px;
  border-radius: 16px 16px 0px 0px;
  background: #fff;
  border: 0.8px solid #dce0e8;
  border-bottom: none;
  cursor: pointer;

  * {
    pointer-events: none;
  }
`

export const Profile = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const Avatar = styled.div`
  width: ${({ theme }) => theme.zds.size.variant210};
  height: ${({ theme }) => theme.zds.size.variant210};
  border-radius: 100%;
  background: linear-gradient(225deg, #061d38 14.64%, #1774de 85.36%);

  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    color: #fff;
  }
`
